import {
  ACTION_PUT_FEATURE,
  ACTION_PUT_FEATURES_SUCCESS_MANAGE,
  ACTION_PUT_FEATURES_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { track } from '../../../analytics/analytics';
import { enqueueSnackbarHandler } from '../../Status';

export function putFeature(
  data: any,
  name: string,
  confidenceUpdated: boolean,
  scopeUpdated: boolean,
) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'feature-flag',
        method: 'PUT',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { updateFeatureSuccess: true },
              'success',
            );
            dispatch(requestSuccess(response, name));
            handleTrack(data, confidenceUpdated, scopeUpdated);
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_FEATURE,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object, name: string) {
  return {
    type: ACTION_PUT_FEATURES_SUCCESS_MANAGE,
    payload: { resp: responseJSON, name: name },
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_FEATURES_FAILURE,
    payload: responseJSON,
  };
}

function handleTrack(
  data: any,
  confidenceUpdated: boolean,
  scopeUpdated: boolean,
) {
  let properties = {
    'Feature Flag': _.get(data, 'name', ''),
    'Confidence Updated': confidenceUpdated,
    'Scope Updated': scopeUpdated,
  };
  const scopeEmpty = _.isEmpty(_.get(data, 'scope', ''));

  if (confidenceUpdated) {
    _.set(properties, 'Confidence', _.get(data, 'confidence', ''));
  }

  if (scopeUpdated) {
    _.set(properties, 'Scope', scopeEmpty ? 'all' : 'beta');
  }

  track('BB_FeatureFlagUpdated', properties);
}
